import React, { type ReactNode } from 'react';
import styled from 'styled-components';
import { Spacing16 } from 'autogen/design-tokens/tokens';
import Flex, { type FlexElementProps, type FlexProperties } from '../Flex';

type FlexColumn = { children: ReactNode } & Omit<FlexProperties, 'direction'> & FlexElementProps;

const FlexColumnComponent = React.forwardRef<HTMLDivElement, FlexColumn>(
    ({ gap = Spacing16, children, ...restProps }, ref) => (
        <Flex ref={ref} {...restProps} gap={gap} direction="column">
            {children}
        </Flex>
    )
);

export default styled(FlexColumnComponent)``;
